import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import TrustBar from "@/components/site/TrustBar";
import ApproachBlock from "@/components/site/ApproachBlock";
import AboutBlock from "@/components/site/AboutBlock";
import Testimonials from "@/components/site/Testimonials";
import CTABanner from "@/components/site/CTABanner";
import usePageTitle from "@/lib/usePageTitle";

export default function Home() {
  usePageTitle();
  return (
    <div data-testid="page-home">
      <Hero />
      <Services />
      <TrustBar />
      <ApproachBlock />
      <AboutBlock />
      <Testimonials />
      <CTABanner />
    </div>
  );
}
